import { reactive } from "vue";
import { api, User } from "~/api";
import { Log } from "~/extensions/utils";
import { myPageStore } from "~/store/MyPageStore";
import { store as nyukyoStore } from "~/pages/nyukyoInfo/store/NyukyoStore";
import { store as taikyoStore } from "~/pages/taikyo/store/TaikyoStore";
import { UserKb } from "~/extensions/utils/DefineTypes";
import Cookies from 'quasar/src/plugins/cookies/Cookies.js';
const log = Log.create("app");
class Auth {
    user = null;
    sessionTimeoutHandled = false;
    get isAuthenticated() {
        return this.user != null;
    }
    get userInfo() {
        return this.user ?? new User();
    }
    get isMt() {
        return this.userInfo.userKbn === UserKb.Mt;
    }
    get isTenant() {
        return this.userInfo.userKbn === UserKb.Tenant;
    }
    get isPasswordReset() {
        return this.user?.isPasswordReset ?? false;
    }
    set isPasswordReset(value) {
        if (!this.user) {
            return;
        }
        this.user.isPasswordReset = value;
    }
    async init() {
        try {
            this.user = await api.auth.user();
        }
        catch (ex) {
            log.error("init", ex);
        }
    }
    async logout() {
        await api.auth.logout();
        this.logoutLocal();
    }
    logoutLocal() {
        this.user = null;
        //storeのクリア
        myPageStore.clear();
        nyukyoStore.clear();
        taikyoStore.clear();
        Cookies.remove("informationDetailBeforeRoute");
    }
    canAccess(to, from) {
        if (this.isAuthenticated) {
            return to.name !== "login";
        }
        return to.name === "login";
    }
}
export const auth = reactive(new Auth());
